import { TypedTypePolicies } from "../graphql/apolloHelpers";

export const typePolicies: TypedTypePolicies = {
  ServiceProduct: {
    keyFields: ["code"],
  },
};
